// extracted by mini-css-extract-plugin
export var active = "_m2-2";
export var recordingDot = "_m2-1";
export var recordingIndicator = "_m2-0";